import classNames from 'classnames';
import React from 'react';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';
import checkBoldIcon from '../../icons/non-prefilled/16x16/checkBold.svg';
import SVGIcon from '../SVGIcon';
import Tooltip from '../Tooltip';
import * as styles from './CheckRadioControl.module.scss';

export interface CheckRadioControlProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: React.ReactNode;
}

const CheckRadioControl = ({
  error,
  label,
  ...inputProps
}: CheckRadioControlProps) => {
  const Component = label ? 'label' : 'div';
  const isCheckbox = inputProps.type === 'checkbox';

  return (
    <Component
      className={classNames(styles.radioControl, {
        [styles.error]: error,
      })}
    >
      <input {...inputProps} />
      <div
        className={classNames(
          isCheckbox ? styles.fakeCheckbox : styles.fakeRadio,
          { [styles.hasLabel]: label },
        )}
      >
        {isCheckbox ? (
          <SVGIcon className={styles.indicator}>{checkBoldIcon}</SVGIcon>
        ) : (
          <div className={styles.indicator} />
        )}
      </div>
      {label}
      {error && (
        <div className={styles.errorContainer}>
          <Tooltip
            display="block"
            content={error}
            danger
            offset={4}
            enabledForSmallSize
          >
            <SVGIcon>{alertIcon}</SVGIcon>
          </Tooltip>
        </div>
      )}
    </Component>
  );
};

export default CheckRadioControl;
